import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { graphql, Link } from "gatsby"
import React from "react"
import { Badge, Col, Container, Image, Row } from "react-bootstrap"
import { PageLayout, PageTitle } from "../components"
import { SEO } from "../utils"

const MediaItem = ({ title, author, link }) => (
  <li className="bio-media-item">
    <a href={link} target="_blank" rel="noopener noreferrer">
      {title}
    </a>
    <span className="bio-media-author"> — <i>{author}</i></span>
  </li>
)

export default ({ data }) => {
  const {
    author,
    occupation,
    readingList,
    gamingList,
    designations,
    unemployed,
  } = data.site.siteMetadata

  const socialLinks = [
    { href: "https://www.youtube.com/@regisatemengue", icon: ["fab", "youtube"], label: "YouTube", cls: "youtube" },
    { href: "https://www.github.com/atemengue", icon: ["fab", "github"], label: "GitHub", cls: "github" },
    { href: "https://linkedin.com/in/regis-atemengue/", icon: ["fab", "linkedin"], label: "LinkedIn", cls: "linkedin" },
    { href: "https://www.twitter.com/regis_ate", icon: ["fab", "twitter"], label: "Twitter", cls: "twitter" },
    { href: "mailto:moafembe@gmail.com", icon: ["fas", "envelope"], label: "Email", cls: "mail" },
  ]

  return (
    <PageLayout pageName="page-about">
      <SEO title="Biographie" />
      <PageTitle title="Biographie" />
      <Container className="py-4">

        {/* Designations */}
        <div className="text-left mb-4">
          {designations.map(attr => (
            <Badge key={attr} className="bio-designation-badge mx-1 mb-2">
              {attr}
            </Badge>
          ))}
        </div>

        {/* Photo + Texte */}
        <Row className="text-left align-items-center mb-5">
          <Col md="7" className="mb-4 mb-md-0">
            <p className="text-lef">
              Hello <span role="img" aria-label="wave">👋🏽</span> Moi c'est{" "}
              <b>{author}</b>. Je suis <b>{occupation}</b> et je suis originaire
              de la région de l'EST du CAMEROUN{" "}
              <span role="img" aria-label="cameroun">🇨🇲</span>, actuellement
              basé à Montréal{" "}
              <span role="img" aria-label="canada">🇨🇦</span>.
            </p>
            <p>
              Mes spécialités sont l'architecture logicielle, les systèmes
              d'information et les bases de données. J'aime dispenser des cours
              de développement web aux personnes intéressées par les
              technologies.
            </p>
            <p>
              Mon temps libre je le partage avec ma famille et mes amis. J'ai
              pris la pilule rouge{" "}
              <span role="img" aria-label="pillules">🔴🆚🔵💊</span> pour
              comprendre la MATRIX 😂 et revenir dans le monde réel. J'ai
              d'autres hobbies comme la musique, la lecture, les randonnées et
              le sport{" "}
              <span role="img" aria-label="sport">🏃🏾‍♂️</span>.
            </p>
            <p>
              Consultez mes <Link to="/projets"><b>projets</b></Link> pour voir
              ce que j'ai fait, ou mon <Link to="/blog"><b>blog</b></Link> pour
              voir ce qui a récemment attiré mon attention !
            </p>

            {/* Liens sociaux */}
            <div className="d-flex bio-social-links mt-3">
              {socialLinks.map(({ href, icon, label, cls }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={label}
                  className="mr-3"
                >
                  <FontAwesomeIcon
                    size="lg"
                    icon={icon}
                    className={`icons ${cls}`}
                  />
                </a>
              ))}
            </div>
          </Col>

          <Col md="5">
            <Image
              thumbnail
              src="/images/regis-sourire-2.jpg"
              alt={author}
              className="w-100"
            />
          </Col>
        </Row>

        {/* Disponibilité */}
        {unemployed && (
          <>
            <hr />
            <p className="unemployed text-left">
              <small>
                <b>Je suis disponible pour des collaborations</b> ! Si vous
                aimez ce que vous <Link to="/cv">voyez</Link>, entrons
                en{" "}
                <a
                  href="mailto:moafembe@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  contact
                </a>{" "}
                !
              </small>
            </p>
          </>
        )}

        <hr />

        {/* Livres & Jeux */}
        <Row className="mt-4">
          <Col md="6" className="mb-4">
            <h5 className="watch-list-title text-left mb-3">
              📚 Ma liste de lecture
            </h5>
            <ul className="bio-media-list text-left">
              {readingList.map(book => (
                <MediaItem key={book.title} {...book} />
              ))}
            </ul>
          </Col>
          <Col md="6">
            <h5 className="watch-list-title text-left mb-3">
              🎮 Ma liste de jeux vidéo
            </h5>
            <ul className="bio-media-list text-left">
              {gamingList.map(game => (
                <MediaItem key={game.title} {...game} />
              ))}
            </ul>
          </Col>
        </Row>

      </Container>
    </PageLayout>
  )
}

export const query = graphql`
  query {
    site {
      siteMetadata {
        unemployed
        occupation
        author
        designations
        readingList {
          title
          author
          link
        }
        gamingList {
          title
          author
          link
        }
      }
    }
  }
`
